import React, { Component } from 'react'
import _ from 'lodash'
import Modal from 'react-modal';
import { connect } from 'react-redux'
import { Link } from 'react-router-dom'
import Highlighter from 'components/Highlighter'
import { getFindPutterVM } from 'state/viewModels'
import { hasSeenPutterDisclaimer, setPutterDisclaimerCookie } from 'state/viewModels/helpers'
import { ButtonLink } from 'components/Buttons'
import ControlledTextInput from 'components/ControlledTextInput'
import SuggestedSearchTerms from 'components/SuggestedSearchTerms'
import FilterPutterCategory from '../components/FilterPutterCategory';
import * as actions from 'ducks/modules/findputter' 
import Loading01Img from 'images/1_Create.png'
import Loading02Img from 'images/2_PackageSend.png'
import Loading03Img from 'images/3_Receive.png'
import LoadingMobileImg from 'images/loading_mobile.gif'

export class FindPutter extends Component {

  constructor() {
    super()
    this.state = { 
      ready: null,
      viewAll: true, 
      warningShow: false, 
      warningLinkId: 0, 
      warningLinkClassic: false, 
    }
    this.doViewAll = this.doViewAll.bind(this);
    this.doReset = this.doReset.bind(this);
    this.doShowWarning = this.doShowWarning.bind(this);
  }

  componentWillMount() {
    document.body.classList.add('search-page');
    this.setState({ready: false});
    this.props.loadPutters();
  }

  componentDidMount() {
    window.scrollTo(0, 0);
  }

  componentWillReceiveProps(nextProps) {
    this.setState({ready: !nextProps.loading});
  }

  componentWillUnmount() {
    document.body.classList.remove('search-page');
  }

  doViewAll(){
    this.props.filterPutters()
    this.setState({viewAll:true}); 
  }

  doReset(){
    this.props.filterPutters()
    this.setState({viewAll:false}); 
  }

  selectSearchField(i) {
    this.props.filterPutters(i)
    this.setState({viewAll:false}); 
  }
  
  filterPutterCategory(i) {
    this.props.filterPuttersByCategory(i)
  }  

  doShowWarning(show, id, warningLinkClassic){
    id = id || 0;
	
	
	if(hasSeenPutterDisclaimer()) {
		let customizeUrl = warningLinkClassic ? `/custom-shop/classic.aspx?modelId=${id}` : `/customshop/customize/${id}`;
		window.location.href = customizeUrl;
	} else {
		setPutterDisclaimerCookie();
		this.setState({ warningShow: show, warningLinkId: id, warningLinkClassic}); 
	}
  }

  render() {
    if(!this.state.ready) 
      return ( 
        <div className="page-loading">
          <span className="message">We are loading your</span>
          <span className="message">customization experience</span>
          <img className="mobile" src={LoadingMobileImg} alt="Create your custom design"/>
          <img className="create" src={Loading01Img} alt="Create your custom design"/>
          <img className="package" src={Loading02Img} alt="Package and send your putter to the shop" />
          <img className="receive" src={Loading03Img} alt="Receive your newly customized putter" />
        </div>
      );
     
    var isDefaultView = !this.props.filter;
    var putters = (isDefaultView && !this.state.viewAll) ? _.take(this.props.putters, 15) : this.props.putters; 

    return (
      <div>
        <Modal className="customizer modal-popup send-in-warning-modal" overlayClassName="modal-overlay" isOpen={this.state.warningShow} contentLabel="Reminder">
          <span className="close-modal" onClick={()=>this.doShowWarning(false)}>&times;</span>
          <h1>Reminder</h1>
          <p>
            You are not purchasing a putter.
            This application is used to visualize work that would be performed at the 
            Scotty Cameron Custom Shop on a putter that you already own. <br/>
            <span className="strong"> You must send in a putter after submitting your order. </span>
          </p>
          {this.state.warningLinkClassic &&
            <a className="button" href={`/custom-shop/classic.aspx?modelId=${this.state.warningLinkId}`}>Continue &gt;</a>
          }
          {!this.state.warningLinkClassic && 
            <ButtonLink to={`/customize/${this.state.warningLinkId}/finish`} >Continue &gt;</ButtonLink>
          }
        </Modal>
        <div className="header search-header-img">
          <span className="top-line">SCOTTY CAMERON</span>
          <span className="bottom-line"> CUSTOM SHOP</span>
        </div>
        <div className="search">
          {this.props.showBuyTab &&
          <div className="filter-terms-container">
            <FilterPutterCategory onClick={i => this.filterPutterCategory(i)} category={this.props.category} />
          </div>
          }
          {this.props.category === "all" &&
          <div className="search-input-container">
            <div className="search-input-header">SEARCH</div>
            <ControlledTextInput id="search-input" value={this.props.filter} onChange={this.props.filterPutters} autoFocus 
              placeholder="Type your putter's model name here."/>
            <SuggestedSearchTerms 
              onViewAll={this.doViewAll}
              onReset={this.doReset}
              onClick={i => this.selectSearchField(i)}/>
          </div>
          }
          {isDefaultView && !this.state.viewAll &&
            <div className="most-recent-header">Most Recent</div>
          }
          <div className="search-results-grid">
            {putters.map((group, i) => {
              return (
                <div key={`t${group.id}`} className={`search-results-item ${this.props.category}`}>
                  {group.is_exact_match &&
                    <div>
                      {/* Change this link to buy when that is selected */}
                      <Link onClick={(evt) => {
                          if(this.props.category === "all"){ 
                            this.doShowWarning(true, group.id);
                            evt.preventDefault();
                            return false;
                          }
                        }} 
                        to={this.props.category === "all" ?
                              `/customize/${group.id}/finish` :
                              `/customize/${group.id}/buy`} 
                        className="putter-label-link">

                        <img src={group.image_url + "&wid=400&hei=400"} alt={group.label}
                          className="putter-image" 
                        />
                        <div className="putter-label">
                          {this.props.category === "buy" &&
                          <div className='new'>NEW</div>
                          }
                          <Highlighter
                            className='putter-title'
                            highlightClassName='highlight'
                            searchWords={group.keywords}
                            textToHighlight={group.label}
                          />
                          {this.props.category === "buy" &&
                          <div className='buy-content'>
                            <div className='putter-price'>${group.putter_price}</div>
                            <div className='putter-desc' dangerouslySetInnerHTML={{__html:group.description}}></div>
                          </div>
                          }
                        </div>
                      </Link>
                    </div>
                  }
                  {group.is_exact_match && 
                    <div className="bottom">
                      {this.props.category === "all" &&
                        <ButtonLink onClick={(evt) => {this.doShowWarning(true, group.id); evt.preventDefault(); return false;}}
                          to={`/customize/${group.id}/finish`} >Customize &gt;</ButtonLink>
                      }
                      {this.props.category === "all" && group.buy_a_putter_id && 
                          <ButtonLink className="buy-link" to={`/customize/${group.buy_a_putter_id}/buy`} >Buy &amp; Customize &gt;</ButtonLink>
                      }
                      {this.props.category === "buy" && group.buy_a_putter && 
                        <ButtonLink className="buy-link" to={`/customize/${group.id}/buy`} >Buy &amp; Customize &gt;</ButtonLink>
                      }
                    </div> 
                  }
                  {!group.is_exact_match &&
                    <div>
                      <a onClick={(evt) => {this.doShowWarning(true, group.id, true); evt.preventDefault(); return false;}} 
                        href={"/custom-shop/classic.aspx?modelId=" + group.id}
                        className="putter-label-link"> 
                        <img src={group.image_url + "&wid=400&hei=400"} alt={group.label}
                          className="putter-image" 
                        />
                        <div className="putter-label">
                          <Highlighter
                            highlightClassName='highlight'
                            searchWords={group.keywords}
                            textToHighlight={group.label}
                          />
                        </div>
                      </a>
                    </div>
                  }
                  {!group.is_exact_match && 
                    <div className="bottom">
                      <div className="not-available-text">
                        <div>
                          <a onClick={(evt) => {this.doShowWarning(true, group.id, true); evt.preventDefault(); return false;}}
                            href={"/custom-shop/classic.aspx?modelId=" + group.id}>Use our Classic Form.</a></div>
                      </div>
                    </div>
                  }
                  <div className="buy-border"></div>
                </div>
              )
            })}
          </div>
          {!!this.props.filter && (!putters || (!!putters && putters.length === 0)) &&
            <div>
              <div className="no-results-header">No results found.</div>
              <div className="no-results-text">Check to see if you might have misspelled something or try simplifying your search to something like "newport or "select".</div>
            </div>
          }
          {!!this.props.filter && !!putters &&
            <div className="dont-see-putter-text">Don't see your putter in the list? <a href="/custom-shop/classic.aspx">Use our Classic Form.</a></div>
          }
        </div>
      </div>
    );
  }
}

FindPutter.defaultProps = {
  loadPutters: () => { },
  filterPutters: () => { },
  filterPuttersByCategory: () => { },
  putters: [],
  filter: "",
  category: "all",
}

const mapStateToProps = (state, ownProps) => { 
  return { ...getFindPutterVM(state) }
}

const mapDispatchToProps = {
  loadPutters: actions.loadPutters,
  filterPutters: actions.setPutterFilterText,
  filterPuttersByCategory: actions.setPutterFilterCategory,
}

export default connect(mapStateToProps, mapDispatchToProps)(FindPutter);